<ng-container *ngIf="(haveAccessToPermit$ | async) === true">
    <div class="root" *transloco="let t; read:'permit'">
        <div class="root__tab-menu">
            <div #tabItem class="item item--initial" [class.item--active]="selectedListType === PermitListType.Ongoing" (click)="changeTab(PermitListType.Ongoing)"
                    [innerHtml]="t('list.ongoing')"></div>
            <div #tabItem class="item" [class.item--active]="selectedListType === PermitListType.Planned" (click)="changeTab(PermitListType.Planned)"
                    [innerHtml]="t('list.planned')"></div>
            <div #tabItem class="item" [class.item--active]="selectedListType === PermitListType.Completed" (click)="changeTab(PermitListType.Completed)"
                    [innerHtml]="t('list.completed')"></div>
            <div class="indicator" [@tabIndicator]="tabIndicatorState"></div>
        </div>

        <div class="root__divider"></div>

        <div class="root__mobile-actions" [class.root__mobile-actions--no-new-permit-button]="(isHotworkerOrPremiumIssuer$ | async) !== true && (isPremiumSuperintendent$ | async) !== true">
            <ng-container *ngIf="permitsToSign$ | async as permitsToSign">
                <div class="root__sign-request" *ngIf="permitsToSign.length > 0" (click)="signPermit(permitsToSign[0])">
                    <div class="root__sign-request__icon"></div>
                    <div class="root__sign-request__text" [innerHTML]="(isMobile$ | async) ? t('signature-notice.signMobile') : t('signature-notice.sign')"></div>
                </div>
            </ng-container>

            <ng-container *ngIf="permitsToClaim$ | async as permitsToClaim">
                <div class="root__claim-request" *ngIf="permitsToClaim.length > 0" (click)="signPermit(permitsToClaim[0], true)">
                    <div class="root__claim-request__icon"></div>
                    <div class="root__claim-request__text" [innerHTML]="(isMobile$ | async) ? t('signature-notice.claimMobile') : t('signature-notice.claim')"></div>
                </div>
            </ng-container>

            <ng-container *ngIf="invitations$ | async as invitations">
                <div class="root__connection-request" *ngIf="invitations.length > 0" (click)="openConnectionRequest()">
                    <div class="root__connection-request__icon"></div>
                    <div class="root__connection-request__text" [innerHTML]="(isMobile$ | async) ? t('subscriptions.alertSingleMobile') : t('subscriptions.alertSingle')"></div>
                </div>
            </ng-container>

            <ng-container *ngIf="permitRequests$ | async as permitRequests">
                <div class="root__permit-request" *ngIf="permitRequests.length > 0" (click)="openPermitRequest()">
                    <div class="root__permit-request__icon"></div>
                    <div class="root__permit-request__text" [innerHTML]="t('permitRequest')"></div>
                </div>
            </ng-container>
        </div>

        <div class="root__buttons">
            <scroll-to-top></scroll-to-top>
            <ng-container *ngIf="(isHotworkerOrPremiumIssuer$ | async) === true">
                <ng-container *ngIf="isPremiumIssuer$ | async">
                    <div class="root__premium-button">
                        <div class="button-content" (click)="onCreatePermit($event, true, false)" [class.button-content--loading]="loading$ | async" [class.button-content--disabled]="(hasValidCertificate$ | async) === false">
                            <span>{{t('createModal.buttonNewPremium')}}</span>
                        </div>
                        <div class="button-chevron" (click)="openCreateModal(PermitCreateMode.Premium)"></div>
                    </div>
                </ng-container>

                <ng-container *ngIf="(isPremiumIssuer$ | async) !== true && !((isHotworkerOrPremiumIssuer$ | async) === false && (showCreateDemoButton$ | async) === true)">
                    <div class="root__base-button">
                        <div class="button-content" (click)="onCreatePermit($event, false, false)" [class.button-content--loading]="loading$ | async" [class.button-content--disabled]="(hasValidCertificate$ | async) === false">
                            <span>{{t('createModal.buttonNewBase')}}</span>
                        </div>
                        <div class="button-chevron" (click)="openCreateModal(PermitCreateMode.Base)"></div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="(isHotworkerOrPremiumIssuer$ | async) === false && (showCreateDemoButton$ | async) === true">
                <div class="root__demo-button">
                    <div class="button-content" (click)="onCreatePermit($event, false, true)" [class.button-content--loading]="loading$ | async">
                        <span>{{t('createModal.buttonNewDemo')}}</span>
                    </div>
                    <div class="button-chevron" (click)="openCreateModal(PermitCreateMode.Demo)"></div>
                </div>
            </ng-container>

            <ng-container *ngIf="(isPremiumSuperintendent$ | async) === true && (isPremiumIssuer$ | async) !== true && (isHotWorker$ | async) !== true">
                <div class="root__superintendent-button">
                    <div class="button-content" (click)="onCreatePermit($event, true, false, PermitType.flammableAtex)" [class.button-content--loading]="loading$ | async">
                        <span>{{t('createModal.buttonNewFlammableAtex')}}</span>
                    </div>
                    <div class="button-chevron" (click)="openCreateModal(PermitCreateMode.Superintendent)"></div>
                </div>
            </ng-container>
        </div>

        <div class="root__filters">
            <div *ngIf="selectedListType === PermitListType.Ongoing" class="root__filters">
                <ha-checkbox *ngIf="hasActiveSubscription$ | async"
                    [(ngModel)]="showAllSubscriptionPermits" [ngModelOptions]="{standalone: true}"
                    (click)="showSubscriptionPermits($event)"
                    [label]="t('showSubscriptionPermits')"
                    class="root__subscription-checkbox">
                </ha-checkbox>
                <ha-checkbox *ngIf="(hasActiveSubscription$ | async) !== true"
                    [(ngModel)]="showAllSubscriptionPermits" [ngModelOptions]="{standalone: true}"
                    [disabled]="true"
                    [label]="t('showSubscriptionPermits')"
                    class="root__subscription-checkbox">
                </ha-checkbox>

                <div class="filter">
                    <div *ngIf="filteredPermits$ | async as filter" class="filter__bar">
                        <div *ngIf="filter.length > 0" (click)="toggleFilter($event)" class="filter__bar__button">
                            <div class="filter__bar__button__icon"></div>
                            <div class="filter__bar__button__text">{{ t("filter") }}</div>
                            <div class="filter__bar__button__count" [innerHTML]="(selectedWorkplaces$ | async)?.length"></div>
                        </div>
                        <div *ngIf="filter.length === 0" class="filter__bar__button-disabled">
                            <div class="filter__bar__button-disabled__icon"></div>
                            <div class="filter__bar__button-disabled__text">{{ t("filter") }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="loader" *ngIf="loading$ | async"></div>

        <pmt-permit-list *ngIf="selectedListType === PermitListType.Ongoing" [permits]="filteredPermits$ | async"></pmt-permit-list>
        <pmt-permit-list *ngIf="selectedListType === PermitListType.Planned" [permits]="plannedPermits$ | async"></pmt-permit-list>

        <ng-container *ngIf="selectedListType === PermitListType.Completed">
            <pmt-permit-list [permits]="completedPermits$ | async" [listType]="PermitListType.Completed"></pmt-permit-list>
        </ng-container>
    </div>
</ng-container>

<pmt-no-access *ngIf="(haveAccessToPermit$ | async) === false"></pmt-no-access>
